/**
 * @author      jose.lucena@zumper.com (José Lucena)
 * @copyright   Copyright (c) 2025, Zumper
 * @description Metro rent report constants
 */

export const RECEIVE_DATA = '@@nzr/modals/metroRentReport/RECEIVE_DATA'
